import React from "react";
import "components/Project-detail-shared/project-detail-shared.scss";
import "./project-challenge-solution-results.scss";

const ProjectChallengeSolutionResults = ({ projectData, caseStudyData }) => {
  const challengeCards = caseStudyData?.challengeCards || [];
  const solutionCards = caseStudyData?.solutionSteps || [];
  const impactCards = caseStudyData?.impactCards || [];

  const hasChallenge = !!caseStudyData?.challengeDescription || challengeCards.length > 0;
  const hasSolution = !!caseStudyData?.solutionDescription || solutionCards.length > 0;
  const hasImpact = !!caseStudyData?.impactDescription || impactCards.length > 0;

  return (
    <>
      {/* 1. The Challenge */}
      {hasChallenge && (
      <section className="pd-section section-padding pb-0 pd-challenge-section">
        <div className="container">
          <div className="section-head mb-40">
            <h2 className="pb-2">The Challenge</h2>
            {caseStudyData?.challengeDescription && (
              <p className="pd-section-desc">{caseStudyData.challengeDescription}</p>
            )}
          </div>
          <div className="row">
            {challengeCards.map((card, idx) => (
              <div className="col-lg-4 mb-30" key={idx}>
                <div className="pd-card pd-grid-card h-100 wow fadeInUp" data-wow-delay={`${idx * 0.1}s`}>
                  <div className="pd-grid-card-icon pd-icon-warning">
                    {card.customIcon ? (
                      <img src={card.customIcon} alt={card.title} style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
                    ) : card.icon ? (
                      <i className={`fas ${card.icon}`}></i>
                    ) : null}
                  </div>
                  <div className="pd-grid-card-content">
                    <h4>{card.title}</h4>
                    <p>{card.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* 2. Our Solution (Timeline/Stepper) */}
      {hasSolution && (
      <section className="pd-section section-padding pb-0 pd-solution-section">
        <div className="container">
          <div className="section-head mb-40">
            <h2 className="pb-2">Our Solution</h2>
            {caseStudyData?.solutionDescription && (
              <p className="pd-section-desc">{caseStudyData.solutionDescription}</p>
            )}
          </div>
          <div className="pd-solution-stepper">
            {solutionCards.map((card, idx) => (
              <div className="pd-solution-step wow fadeInRight" data-wow-delay={`${idx * 0.1}s`} key={idx}>
                <div className="pd-step-icon">
                  {card.customIcon ? (
                    <img src={card.customIcon} alt={card.title} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                  ) : card.icon ? (
                    <i className={`fas ${card.icon}`}></i>
                  ) : null}
                </div>
                <div className="pd-step-content">
                  <h5>{card.title}</h5>
                  <p>{card.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* 3. Business Impact */}
      {hasImpact && (
      <section className="pd-section section-padding pd-impact-section">
        <div className="container">
          <div className="section-head mb-40">
            <h2 className="pb-2">Business Impact</h2>
            {caseStudyData?.impactDescription && (
              <p className="pd-section-desc">{caseStudyData.impactDescription}</p>
            )}
          </div>
          <div className="row">
            {impactCards.map((card, idx) => (
              <div className="col-lg-6 mb-30" key={idx}>
                <div className="pd-card pd-grid-card h-100 wow fadeInUp" data-wow-delay={`${idx * 0.1}s`}>
                  <div className="pd-icon-cyan">
                    {card.customIcon ? (
                      <img src={card.customIcon} alt={card.title} style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
                    ) : card.icon ? (
                      <i className={`fas ${card.icon}`}></i>
                    ) : null}
                  </div>
                  <div className="pd-grid-card-content">
                    <h4>{card.title || card.value}</h4>
                    <p>{card.text || card.label}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}
    </>
  );
};

export default ProjectChallengeSolutionResults;
